import React, { useState } from "react";

type ProductCardProps = {
  image: string;
  title: string;
  price: string;
  color: string;
};

const ProductCard: React.FC<ProductCardProps> = ({
  image,
  title,
  price,
  color,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="flex items-center gap-4 p-4 bg-white border-1 w-full rounded-lg border border-gray-200">
        <div
          className="w-16 h-16 flex-shrink-0 rounded-lg bg-gray-100 flex items-center justify-center overflow-hidden group cursor-pointer"
          onClick={() => setIsModalOpen(true)}
        >
          <img
            src={image}
            alt={title}
            className="w-full h-full object-contain transform transition-transform duration-300 group-hover:scale-110"
          />
        </div>
        <div className="flex flex-col">
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          <p className="text-md font-bold text-black">{price}</p>
          <p className="text-xs text-gray-500">Color: {color}</p>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="bg-white p-4 rounded-lg shadow-lg max-w-lg w-full relative"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
          >
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
              onClick={() => setIsModalOpen(false)}
            >
              ✕
            </button>
            <img src={image} alt={title} className="w-full h-auto rounded-lg" />
          </div>
        </div>
      )}
    </>
  );
};

export default ProductCard;
